import React from 'react';
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import { FormInput, FormMaskedTextBox, FormDropDownList, FormNumericTextBox, FormColorGradient, FormCheckbox, EmailInput, FormTextArea, FormDatePicker, FormDateRangePicker } from '../../../../Utils/form-components';
import { Button } from '@progress/kendo-react-buttons';
import { Upload } from '@progress/kendo-react-upload';
import { Loader } from '@progress/kendo-react-indicators';
import { emailValidator, myInputValidator } from "../../../../Utils/validators"
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import '../CampaignHome.css'
import { saveCampaign, saveCampaigns } from '../../../../Api/CampaignApi';

export default function AddCampaigns(props) {
    const handleSubmit = async dataItem => {
        let saveData = {
            "Id": 0,
            "Title": dataItem.title,
            "startCampaignDate": dataItem.campaignDate?.start || new Date().toISOString,
            "endCampaignDate": dataItem.campaignDate?.end || dataItem.campaignDate?.start || new Date().toISOString,
            "status": "Pending",
            "redirectURL": dataItem.redirectURL,
            "description": dataItem.description,


            "adsClientId": JSON.parse(localStorage.getItem("userId"))
        }

        try {
            await saveCampaign(saveData).then(() => {
                props.setAlertMessage("Saved Campaign")
                props.onTriggerAlert('success')

                props.toggleRefresh()
                props.closeDialog()
            });
        } catch (error) {

            props.setAlertMessage(error)
            props.onTriggerAlert('error')
            console.log(error);
        }
    }

    return (
        <Dialog >
            <Form onSubmit={handleSubmit} render={formRenderProps => <FormElement style={{ padding: "12px", width: "40vw" }}>
                <fieldset className={'k-form-fieldset'} >
                    <div className="form-subheading">Add Campaign</div>
                    <div className='field-wrapper' >
                        <Field id={'title'} name={'title'} label={'Title'} component={FormInput} />
                        <Field id={'redirectURL'} name={'redirectURL'} label={'Redirect Url'} component={FormInput} hint={'Hint: Website URL that will redirect to when clicked'}
                        />
                    </div>

                    <div className='field-wrapper' >
                        <Field id={'campaignDate'} name={'campaignDate'} label={'Campaign Date'} component={FormDateRangePicker} validator={myInputValidator} />
                    </div>

                    <div className='field-wrapper' >
                        <Field style={{ width: '40vw' }} width={"500px"} id={'description'} name={'description'} label={'Description'} component={FormTextArea} />
                    </div>
                    <span className={'k-form-separator'} />

                    <div className="k-form-buttons" style={{ float: "right" }}>
                        <Button
                            themeColor={"primary"}
                            type={"submit"}
                            disabled={!formRenderProps.allowSubmit}
                        >
                            Add Campaign
                        </Button>
                        <Button onClick={props.closeDialog}>
                            Cancel
                        </Button>
                    </div>
                </fieldset>
            </ FormElement>} />
        </Dialog>

    )
}